<template>
    <div class="colud-home-box" v-if="Object.keys(this.form).length">
        <navBar></navBar>
        <div class="content">
            <!-- 上上参谋企业版 -->
            <div class="banner-box">
                <div class="bag">
                    <img :src="form.bannerObj.img" alt="" v-img="{ form: form.bannerObj, key: 'img' }" />
                </div>
                <div class="img-text">
                    <div class="left-box wow fadeInUp">
                        <p class="name pingFang-Heavy font60" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                        <p class="c-text font24" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</p>
                    </div>
                    <div></div>
                </div>
            </div>
            <!-- 智能决策平台，支撑品牌全流程高效、高质量决策 -->
            <div class="cell-box ptb100">
                <div class="container1">
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                    </div>
                    <div class="module-box mt-60-bootstrap">
                        <div v-for="(item, index) in form.firstObj.list" :key="index" class="module module-hover wow fadeInUp">
                            <div class="list">
                                <div class="m-img" v-img="{ form: item, key: 'src' }"><img :src="item.src" /></div>
                                <div class="module-title pingFang-Heavy" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                <div class="text pingFang-Medium" v-edit="{ form: item, key: 'text' }" v-html="item.text"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 红餐网 -->
            <div class="redFood ptb100">
                <div class="container1">
                    <div class="left">
                        <img :src="form.secoundObj.img" v-img="{ form: form.secoundObj, key: 'img' }" alt="" />
                    </div>
                    <div class="right">
                        <div class="redFood-title pingFang-Heavy" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</div>
                        <div class="redFood-content pingFang-Medium" v-edit="{ form: form.secoundObj, key: 'content' }" v-html="form.secoundObj.content"></div>
                    </div>
                </div>
            </div>
            <!-- 数据+模型+工具，专业的拓店决策系统 -->
            <div class="data-model ptb100">
                <div class="container1">
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40 " v-edit="{ form: form.thiredObj, key: 'title' }">{{ form.thiredObj.title }}</p>
                    </div>
                    <div class="data-model-tabs mt-60-bootstrap">
                        <div
                            class="data-model-tabs-item"
                            @click="dataModelActive = index"
                            :class="{ active: dataModelActive === index }"
                            v-for="(item, index) in form.thiredObj.list"
                            :key="index"
                        >
                            <img v-img="{ form: item, key: 'img' }" :src="item.img" alt="" />
                            <div class="data-model-tabs-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <template v-for="(item, index) in form.thiredObj.list">
                    <div class="data-model-content" :key="index" v-if="dataModelActive === index">
                        <div class="container1">
                            <div class="data-model-content-left">
                                <img :src="item.children.img" alt="" v-img="{ form: item.children, key: 'img' }" />
                            </div>
                            <div class="data-model-content-right">
                                <div class="data-model-content-right-title" v-edit="{ form: item.children, key: 'title' }">
                                    {{ item.children.title }}
                                </div>
                                <div class="data-model-content-right-content" v-edit="{ form: item.children, key: 'content' }">
                                    {{ item.children.content }}
                                </div>
                                <div class="data-model-content-right-textList">
                                    <div class="right-text" v-for="(text, index) in item.children.textList" v-edit="{ form: item.children.textList, key: index }" :key="index">
                                        {{ text }}
                                    </div>
                                </div>
                                <div class="data-model-content-right-btn" v-edit="{ form: item.children, key: 'buttonText' }" @click="visible = true">
                                    {{ item.children.buttonText }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <!-- 拓店云智能决策应用蓝图 -->
            <div class="saas ">
                <div class="container1">
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40 " v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</p>
                    </div>
                    <img class="saas-img mt-60-bootstrap" :src="form.fourthObj.img" alt="" v-img="{ form: form.fourthObj, key: 'img' }" />
                </div>
            </div>
            <!-- 行业标杆案例 -->
            <div class="img-show-box ptb100">
                <div class="container1">
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40 " v-edit="{ form: form.sixthObj, key: 'title' }">{{ form.sixthObj.title }}</p>
                    </div>
                    <div class="img-show-content wow fadeInUp mt-60-bootstrap">
                        <div class="img-show-div" v-for="(item, key) in form.sixthObj.list" :key="key">
                            <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                            <div class="img-name-box">
                                <p class="name-text pingFang-Heavy" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                            </div>
                            <div class="img-text-content animate-module-hide animate-fadeInUp-module">
                                <p class="img-name pingFang-Heavy" v-edit="{ form: item, key: 'contentTitle' }">{{ item.contentTitle }}</p>
                                <p class="img-tips" v-edit="{ form: item, key: 'content' }">
                                    {{ item.content }}
                                </p>
                                <div class="fz_but">
                                    <div @click="jumpPage('/cloudSchemeDetails', key)" v-edit="{ form: item, key: 'buttonContent' }" class="but understand-details">
                                        <span>{{ item.buttonContent }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 与数千家企业共同成长 -->
            <div class="tabs-box logo-plate" id="logo-plate-box">
                <div class="tabs-box-title" v-edit="{ form: form.seventhObj, key: 'title' }">{{ form.seventhObj.title }}</div>
                <div class="tabs-content-box fadeInUp grow-up-together">
                    <div class="logo-list">
                        <div v-for="(item, index) in form.seventhObj.list" :key="index">
                            <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                            <itemAdd :list="form.seventhObj.list" :itemIndex="index"></itemAdd>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 想要了解更多信息或寻求商务合作 -->
            <div class="cooperation-box" v-img="{ form: form.eightthObj, key: 'img' }" :style="'background-image: url(' + form.eightthObj.img + ')'">
                <div class="container1">
                    <div class="cooperation-content">
                        <div class="cooperation-text">
                            <p class="cooperation-text-title" v-edit="{ form: form.eightthObj, key: 'title' }">{{ form.eightthObj.title }}</p>
                        </div>
                        <div class="cooperation-btn" @click="visible = true">立即咨询</div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="161" :id="136"></submit-form>
        <guidance :type="2" :show="show" @hiddenToggle="hiddenToggle"></guidance>
        <form-dialog v-if="visible" @close="visible = false"></form-dialog>
    </div>
</template>

<script>
import navBar from '../../components/cloudNavBar.vue';
import { WOW } from 'wowjs';
import { pageQuery } from '@/api';
import submitForm from '../../components/submit-form.vue';
import itemAdd from '../../components/item-add.vue';
import Guidance from '@/components/guidance.vue';
import formDialog from '../../components/formDialog.vue';
export default {
    name: '',
    data() {
        return {
            show: false,
            typeActiveName: '0',
            domShow: false,
            dataModelActive: 0, //数据+模型+工具tabs栏
            visible: false, //免费试用弹出窗
            hezuo: {
                src: require('../../assets/cloudHome/contact_bg.jpg')
            },
            form: {},
            // form: {
            //     bannerObj: {
            //         img: require('../../assets/cloudHome/banner01.png'),
            //         title: '上上参谋企业版',
            //         content: '为连锁品牌提供战略规划、网规选址、勘店找铺、开店评估的全流程智能决策支持，助力连锁品牌高效、高质量规模化发展。'
            //     },
            //     firstObj: {
            //         title: '智能决策平台，支撑品牌全流程高效、高质量决策',
            //         list: [
            //             {
            //                 title: '单店模型打造',
            //                 text: '深度分析品牌自身门店布局，为品牌沉淀专属单店模型，为品牌高质量规模化扩张打下基础',
            //                 src: require('../../assets/cloudHome/part1_1.jpg'),
            //                 buttonContent: '了解详情'
            //             },
            //             {
            //                 title: '批量甄选黄金位置',
            //                 text: '依托先进的选址模型，智能批量推荐精确到建筑物的位置点，提升规模化扩张效率',
            //                 src: require('../../assets/cloudHome/part1_2.jpg'),
            //                 buttonContent: '了解详情'
            //             },
            //             {
            //                 title: '好店多维度评估',
            //                 text: '依托线下全域商业大数据，从商圈、位置、铺位全面深度评估，有据可循开好店',
            //                 src: require('../../assets/cloudHome/part1_3.jpg'),
            //                 buttonContent: '了解详情'
            //             },
            //             {
            //                 title: '竞争品牌发展监测',
            //                 text: '竞争&协同品牌发展动态持续追踪，全面洞察市场环境，科学制定品牌扩张战略',
            //                 src: require('../../assets/cloudHome/part1_4.jpg'),
            //                 buttonContent: '了解详情'
            //             },
            //             {
            //                 title: '拓店信息资产有效沉淀',
            //                 text: '拓店全流程可查可诉溯，在线记录实勘信息、加盟商看铺信息，业务全流程全数据云端留存',
            //                 src: require('../../assets/cloudHome/part1_5.jpg'),
            //                 buttonContent: '了解详情'
            //             },
            //             {
            //                 title: '线下全域商业分析',
            //                 text: '全域全量的商业数据深度分析，快速锁定目标商圈，找到优质位置点，锁定合适铺位',
            //                 src: require('../../assets/cloudHome/part1_6.jpg'),
            //                 buttonContent: '了解详情'
            //             }
            //         ]
            //     },
            //     secoundObj: {
            //         src: require('../../assets/cloudHome/contact_bg.jpg'),
            //         title: '行业领先地位',
            //         content:
            //             '上上参谋企业版亮相由央广网、红餐网联合举办的“第三届中国餐饮产业峰会”，与美团餐饮系统、客如云、微盟智慧餐饮等行业旗舰产品，共同当选“2023年度餐饮SaaS产品TOP10”',
            //         img: require('../../assets/cloudHome/part2_1.png')
            //     },
            //     thiredObj: {
            //         title: '数据+模型+工具，专业的拓店决策系统',
            //         list: [
            //             {
            //                 img: require('../../assets/cloudHome/part3_1.jpg'),
            //                 title: '全面的数据能力',
            //                 children: {
            //                     title: '全域线下数据，全面支持高效决策',
            //                     content: '覆盖全国686座地县市、超5亿栅格、超8000座购物中心、超40万线下品牌、3000万个商铺，涵括超200数据维度，超3000个数据字段。',
            //                     textList: ['城市宏观数据分析', '商圈客群数据分析', '商场业态数据分析', '外卖订单数据分析', '竟对&协同数据分析'],
            //                     img: require('../../assets/cloudHome/model_pic.png'),
            //                     buttonText: '免费试用'
            //                 }
            //             },
            //             {
            //                 img: require('../../assets/cloudHome/part3_2.jpg'),
            //                 title: '丰富的决策模型',
            //                 children: {
            //                     title: '全域线下数据，全面支持高效决策222222',
            //                     content: '覆盖全国686座地县市、超5亿栅格、超8000座购物中心、超40万线下品牌、3000万个商铺，涵括超200数据维度，超3000个数据字段。',
            //                     textList: ['城市宏观数据分析', '商圈客群数据分析', '商场业态数据分析', '外卖订单数据分析', '竟对&协同数据分析'],
            //                     img: require('../../assets/cloudHome/model_pic.png'),
            //                     buttonText: '免费试用'
            //                 }
            //             },
            //             {
            //                 img: require('../../assets/cloudHome/part3_3.jpg'),
            //                 title: '强大的信息化平台',
            //                 children: {
            //                     title: '全域线下数据，全面支持高效决策4444444',
            //                     content: '覆盖全国686座地县市、超5亿栅格、超8000座购物中心、超40万线下品牌、3000万个商铺，涵括超200数据维度，超3000个数据字段。',
            //                     textList: ['城市宏观数据分析', '商圈客群数据分析', '商场业态数据分析', '外卖订单数据分析', '竟对&协同数据分析'],
            //                     img: require('../../assets/cloudHome/model_pic.png'),
            //                     buttonText: '免费试用'
            //                 }
            //             }
            //         ]
            //     },
            //     fourthObj: {
            //         title: '拓店云智能决策应用蓝图',
            //         img: require('../../assets/cloudHome/part4_1.png')
            //     },
            //     fifthObj: {
            //         title: '标准化项目实施交付流程',
            //         content: '专业团队&nbsp;&nbsp;高效落地&nbsp;&nbsp;持续服务',
            //         list: [
            //             {
            //                 title: '项目启动',
            //                 nei: ['项目确认', '初步调研', '项目启动会'],
            //                 icon: require('../../assets/cloudHome/arrow_1.png')
            //             },
            //             {
            //                 title: '需求调研',
            //                 nei: ['诊断调研', '门店访谈', '门店实勘', '业务蓝图规划'],
            //                 icon: require('../../assets/cloudHome/arrow_2.png')
            //             },
            //             {
            //                 title: '系统培训',
            //                 nei: ['初始化及测试确认', '项目上线动员会', '上线培训及考核'],
            //                 icon: require('../../assets/cloudHome/arrow_3.png')
            //             },
            //             {
            //                 title: '上线验收',
            //                 nei: ['试运行过程辅导', '正式上线及验收'],
            //                 icon: require('../../assets/cloudHome/arrow_4.png')
            //             },
            //             {
            //                 title: '持续运营',
            //                 nei: ['应用巡检及回访', '产品迭代培训', '持续运营保障'],
            //                 icon: require('../../assets/cloudHome/arrow_2.png')
            //             }
            //         ]
            //     },
            //     sixthObj: {
            //         title: '行业标杆案例',
            //         list: [
            //             {
            //                 img: require('../../assets/cloudHome/solution_pic_1.jpg'),
            //                 title: '饮品奶茶',
            //                 contentTitle: '饮品奶茶',
            //                 content:
            //                     '依托智能化产品，数位为餐饮行业数百家连锁品牌提供拓店环节的关键决策支持，覆盖战略规划、网规选址、勘店找铺、开店评估拓店业务全流程。提升品牌拓店效率、保障品牌拓店成功率、降低业务管理成本。',
            //                 buttonContent: '了解详情',
            //                 path: '/cloudSchemeDetails'
            //             },
            //             {
            //                 img: require('../../assets/cloudHome/solution_pic_2.jpg'),
            //                 title: '咖啡烘焙',
            //                 contentTitle: '咖啡烘焙',
            //                 content: '通过“工具+数据+模型”，为连锁便利行业品牌提供一站式数字化解决方案，结合行业专家的经验，基于“好商圈、好位置、好店铺”，提升品牌开店成功率。',
            //                 buttonContent: '了解详情',
            //                 path: '/cloudSchemeDetails'
            //             },
            //             {
            //                 img: require('../../assets/cloudHome/solution_pic_3.jpg'),
            //                 title: '小吃快餐',
            //                 contentTitle: '小吃快餐',
            //                 content:
            //                     '基于上上参谋企业版品牌拓店全流程数字化能力，通过“建标准、管过程、留数据”，为小吃甜点品牌客户提供数字化解决方案，提升品牌开店质量与开店效率，降低品牌规模化开店风险。',
            //                 buttonContent: '了解详情',
            //                 path: '/cloudSchemeDetails'
            //             },
            //             {
            //                 img: require('../../assets/cloudHome/solution_pic_4.jpg'),
            //                 title: '商超便利',
            //                 contentTitle: '商超便利',
            //                 content: '模型”，为速食快餐行业品牌提供一站式数字化解决方案，结合行业专家的经验，基于“好商圈、好位置、好店铺”，提升品牌开店成功率。',
            //                 buttonContent: '了解详情',
            //                 path: '/cloudSchemeDetails'
            //             }
            //         ]
            //     },
            //     seventhObj: {
            //         title: '已服务数千家行业头部企业',
            //         list: [
            //             {
            //                 img: require('@/assets/logo/1.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/2.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/3.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/4.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/5.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/6.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/7.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/8.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/9.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/10.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/11.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/12.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/13.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/14.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/15.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/16.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/17.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/18.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/19.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/20.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/21.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/22.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/23.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/24.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/25.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/26.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/27.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/28.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/29.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/30.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/31.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/32.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/33.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/34.png')
            //             },
            //             {
            //                 img: require('@/assets/logo/35.png')
            //             }
            //         ]
            //     },
            //     eightthObj: {
            //         img: require('../../assets/cloudHome/contact_bg.png'),
            //         title: '全国拓展、好店复制，就用上上参谋企业版'
            //     }
            // }
        };
    },
    mounted() {
        pageQuery({ componentId: '161', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            setTimeout(() => {
                $('.img-show-div').hover(
                    e => {
                        $('.img-show-div').removeClass('active');
                        $('.img-show-div .img-text-content').removeClass('animate-fadeInUp-module');
                        $(e.currentTarget).addClass('active');
                        setTimeout(() => {
                            $(e.currentTarget)
                                .find('.img-text-content')
                                .addClass('animate-fadeInUp-module');
                        }, 100);
                    },
                    e => {}
                );
                this.tabHeaderInitialize();
                $('#logo-plate-box .el-tabs .el-tabs__item').hover(
                    e => {
                        $(e.currentTarget).click();
                    },
                    e => {}
                );
            }, 500);
            this.$nextTick(() => {
                var oT = $(window).height() * 0.1;
                var t = 0.1,
                    e = !0,
                    wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: oT,
                        callback: function(e) {
                            (e = $(e)).css('animation-delay', t.toFixed(1) + 's'), (t += 0.1);
                        }
                    });
                $(window).scroll(function() {
                    e &&
                        ((t = 0.2),
                        setTimeout(function() {
                            e = !0;
                        }, 150),
                        (e = !1));
                }),
                    wow.init();
            });
        });
    },
    methods: {
        showToggle() {
            if (this.$store.state.token) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        jumpPage(target, idx) {
            this.$router.push({
                path: target,
                query: {
                    activeName: idx
                }
            });
        },
        tabHeaderInitialize() {
            let dom = $('.logo-plate .el-tabs__header .el-tabs__nav-scroll');
            let h = dom.find('.el-tabs__item').innerHeight();
            let w = dom.find('.el-tabs__item').innerWidth();
            dom.append(`<div class="slider" style="height:${h}px;width: ${w}px;background-color: #eb5405;border-radius: 50px;"></div>`);

            dom.find('.el-tabs__item').click(e => {
                let idText = $(e.currentTarget).attr('id');
                let index = idText.split('tab-')[1];
                let sliderDom = $(e.currentTarget)
                    .parent()
                    .next();
                sliderDom.css({
                    transform: `translateX(${w * index}px)`
                });
            });
        }
    },
    components: { navBar, submitForm, itemAdd, Guidance, formDialog }
};
</script>

<style scoped lang="less">
@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.colud-home-box {
    width: 100%;
    position: relative;

    .but {
        background-color: #ff5d00;
        padding: 16px 40px;
        font-size: 16px;
        border: none;
        border: 1px solid #ff5d00;
        border-radius: 35px;
        color: #fff;
        display: flex;
        align-content: center;
        width: auto;
        transition: all 0.4s;
        align-items: center;
        margin: 42px 0;
        @media @max-lg {
            margin: 30px 0 0;
            font-size: 14px;
            padding: 14px 32px;
        }
        @media @max-md {
            padding: 12px 24px;
        }
        @media @max-xs {
            margin-top: 24px;
            font-size: 12px;
            padding: 12px 16px;
        }
        i {
            display: block;
            margin-left: 10px;
            font-size: 12px;
        }
        &:hover {
            opacity: 0.9;
        }
    }

    .but-blank {
        background: none;
        border: thin solid #fff;
    }

    .but-blank:hover {
        border-color: #ff5d00;
        background-color: #ff5d00;
        color: #fff !important;
    }
    .content {
        width: 100%;
        margin-top: 80px;
        .banner-box {
            width: 100%;
            height: 820px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            @media @max-lg {
                height: 520px;
            }
            .bag {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: all 0.4s;
                    @media @max-sm {
                        width: 300%;
                    }
                }
            }
            .img-text {
                position: relative;
                z-index: 2;
                width: 36%;
                margin-right: 50%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                @media @max-sm {
                    width: 87.5%;
                    margin-right: 0;
                }
                .left-box {
                    color: #fff;

                    .name {
                        letter-spacing: 1px;
                    }

                    .tip-text {
                        margin-bottom: 5px;
                        letter-spacing: 1px;
                    }
                    .c-text {
                        margin-top: 47px;
                    }
                    .button-box {
                        display: flex;
                        flex-wrap: wrap;
                        .but {
                            margin-bottom: 0;
                            color: #fff;
                        }
                    }
                }
            }
            .text-box {
                width: 100%;
                height: 158px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                overflow-x: auto;

                .background {
                    width: fit-content;
                    height: 130px;
                    display: flex;
                    align-items: center;
                    align-content: flex-start;
                    background-color: rgba(34, 37, 47, 0.5);
                    .text {
                        width: 305px;
                        height: 130px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        box-sizing: border-box;
                        border-right: thin solid #393d47;
                        padding: 0 0 0 36px;
                        color: #fff;
                        flex-shrink: 0;
                        letter-spacing: 1px;
                        .title {
                            font-size: 20px;
                            font-family: 'PingFang-Heavy' !important;
                        }
                        .tips {
                            font-size: 16px;
                            font-family: 'PingFang-Regular' !important;
                        }
                    }
                    .text:last-child {
                        border: none;
                    }

                    .text:hover {
                        height: 158px;
                        position: relative;
                        top: -15px;
                        color: #eb5405;
                        background: url('../../assets/img/b.png');
                        background-size: 100%;
                        padding-top: 30px;
                    }
                    .active-text {
                        height: 158px;
                        position: relative;
                        top: -15px;
                        color: #eb5405;
                        background: url('../../assets/img/b.png');
                        background-size: 100%;
                        padding-top: 30px;
                    }
                }
            }
        }
        .banner-box:hover .right-img {
            animation: fadeInUp 2s ease forwards;
        }
        .cell-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            box-sizing: border-box;
            .container1 {
                max-width: 1616px;
                @media @min-md {
                    width: 88%;
                }
            }
            .box-title {
                color: #000;
                letter-spacing: 1px;
            }
            .tips {
                color: #65697f;
                margin-bottom: 41px;
                letter-spacing: 1px;
            }

            .module-box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                margin-right: -22px;
                margin-bottom: -22px;
                .module {
                    margin: 0 22px 22px 0;
                    width: 31%;
                    height: 250px;
                    transition: all 0.4s;
                    @media @max-md {
                        width: 47%;
                        height: 250px;
                    }
                    @media @max-sm {
                        width: 100%;
                        height: 250px;
                    }
                    .list {
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        background: #ffffff;
                        box-shadow: 0px 2px 54px 0px rgba(17, 17, 17, 0.08);
                        flex-shrink: 0;
                        transition: all 0.8s;
                        .m-img {
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 30px;
                            img {
                                height: 61.3px;
                                width: auto;
                            }
                        }
                        .module-title {
                            font-size: 28px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 1.25;
                            transition: all 0.8s;
                            @media @max-md {
                                font-size: 26px;
                            }
                            @media @max-sm {
                                font-size: 24px;
                            }
                        }
                        .text {
                            color: #65697f;
                            font-size: 16px;
                            overflow: hidden;
                            line-height: 26px;
                            margin-top: 14px;
                            max-width: 70%;
                            transition: all 0.8s;
                            @media @max-lg {
                                line-height: 24px;
                                font-size: 14px;
                            }
                            @media @max-xs {
                                line-height: 22px;
                            }
                        }

                        .but-box {
                            height: 50px;
                            direction: flex;
                            align-items: center;
                            justify-content: center;
                            margin-top: 20px;
                            @media @max-xs {
                                display: none;
                            }
                            .but {
                                display: none;
                                margin: 0;
                                justify-content: center;
                            }
                        }
                    }
                }

                .module-hover:hover {
                    .m-img {
                        animation: moduleUp 2s ease forwards;
                    }
                    .module-title {
                        color: #eb5405;
                    }
                    .but-box {
                        .but {
                            display: flex;
                            animation: fadeInUp 1s ease forwards;
                        }
                    }
                }
            }
        }
        .redFood {
            background: linear-gradient(-8deg, #fea402, #ff5d00);
            .container1 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                .left {
                    flex-shrink: 0;
                    margin-right: 107px;
                    transition: all 0.4s;
                    > img {
                        width: auto;
                        height: 91px;
                    }
                }
                .right {
                    flex: 1;
                    transition: all 0.4s;
                    .redFood-title {
                        font-size: 40px;
                        font-weight: 500;
                        color: #ffffff;
                        line-height: 72px;
                    }
                    .redFood-content {
                        font-size: 18px;
                        color: #ffffff;
                        line-height: 26px;
                    }
                }
                @media @max-sm {
                    .left {
                        margin-right: 0px;
                    }
                    .right {
                        flex-basis: 100%;
                        margin-top: 16px;
                    }
                }
            }
        }
        .data-model {
            display: flex;
            align-items: center;
            flex-direction: column;
            .data-model-tabs {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all 0.4s;
                .data-model-tabs-item {
                    width: 30%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    cursor: pointer;
                    > img {
                        width: auto;
                        height: 71px;
                        transition: all 0.4s;
                    }
                    .data-model-tabs-item-title {
                        font-size: 22px;
                        font-weight: 500;
                        color: #8d8d8d;
                        line-height: 28px;
                        transition: all 0.4s;
                        margin: 21px 0 15px 0;
                    }
                }
                @media @max-xs {
                    margin-top: 50px;
                    .data-model-tabs-item {
                        > img {
                            height: 61px;
                        }
                        .data-model-tabs-item-title {
                            font-size: 18px;
                            line-height: 24px;
                        }
                    }
                }
                @media @max-xx {
                    margin-top: 40px;
                    .data-model-tabs-item {
                        > img {
                            height: 51px;
                        }
                        .data-model-tabs-item-title {
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                }
                @media @max-xn {
                    margin-top: 40px;
                    .data-model-tabs-item {
                        > img {
                            height: 41px;
                        }
                        .data-model-tabs-item-title {
                            font-size: 12px;
                            line-height: 18px;
                        }
                    }
                }
                .active {
                    .data-model-tabs-item-title {
                        color: #ff5d00;
                    }
                    border-bottom: 2px solid #ff5d00;
                }
            }
            .data-model-content {
                margin-top: 9px;
                width: 100%;
                background: url('../../assets/cloudProduct/arrow-b.png');
                background-repeat: no-repeat;
                background-size: cover;
                .container1 {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    padding: 51px 0;
                    transition: all 0.4s;
                    .data-model-content-left {
                        flex-shrink: 0;
                        padding-right: 5%;
                        transition: all 0.4s;
                        width: 50%;
                        > img {
                            width: 100%;
                            height: auto;
                            transition: all 0.4s;
                        }
                    }
                    .data-model-content-right {
                        flex-shrink: 0;
                        flex: 1;
                        transition: all 0.4s;
                        .data-model-content-right-title {
                            font-size: 30px;
                            font-weight: bold;
                            color: #252525;
                            line-height: 49px;
                        }
                        .data-model-content-right-content {
                            font-size: 22px;
                            font-weight: 400;
                            color: #252525;
                            line-height: 36px;
                            margin-top: 22px;
                        }
                        .data-model-content-right-textList {
                            display: flex;
                            margin-top: 57px;
                            flex-wrap: wrap;
                            margin-right: -60px;
                            margin-bottom: -16px;
                            .right-text {
                                font-size: 18px;
                                color: #8d8d8d;
                                line-height: 26px;
                                padding-left: 30px;
                                position: relative;
                                display: flex;
                                align-items: center;
                                margin-right: 60px;
                                margin-bottom: 16px;
                            }
                            .right-text::before {
                                content: '';
                                position: absolute;
                                width: 12px;
                                height: 12px;
                                background: #242424;
                                border-radius: 50%;
                                left: 0;
                            }
                        }
                    }
                    .data-model-content-right-btn {
                        margin-top: 56px;
                        width: 131px;
                        height: 46px;
                        border: 1px solid #ff5d00;
                        border-radius: 23px;
                        font-size: 20px;
                        color: #ff5d00;
                        line-height: 72px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                    @media @max-md {
                        .data-model-content-left {
                            width: 45%;
                        }
                    }
                    @media @max-sm {
                        justify-content: center;
                        .data-model-content-left {
                            width: 100%;
                            padding-right: 0px;
                            > img {
                                width: 100%;
                                height: auto;
                            }
                        }
                        .data-model-content-right {
                            margin-top: 16px;
                        }
                    }
                }
            }
        }
        .saas {
            display: flex;
            align-items: center;
            flex-direction: column;
            .saas-img {
                width: 100%;
                height: auto;
                transition: all 0.4s;
                @media @max-sm {
                    margin-top: 40px;
                }
                @media @max-xs {
                    margin-top: 20px;
                }
            }
        }
        .img-show-box {
            width: 100%;
            height: 868px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            box-sizing: border-box;
            @media @max-xs {
                padding: 60px 0;
            }
            .box-title {
                color: #000;
                margin-bottom: 4px;
                letter-spacing: 1px;
                text-align: center;
            }

            .tips {
                color: #65697f;
                text-align: center;
                margin-bottom: 34px;
                letter-spacing: 1px;
                @media @max-lg {
                    margin-bottom: 28px;
                }
                @media @max-sm {
                    margin-bottom: 26px;
                }
            }

            .img-show-content {
                display: flex;
                align-items: center;
                @media @max-sm {
                    flex-wrap: wrap;
                }
                .img-show-div {
                    width: 222px;

                    height: 501px;
                    border-radius: 8px;
                    position: relative;
                    overflow: hidden;
                    transition: width 0.8s;
                    margin-left: 20px;
                    flex: 1 1 auto;
                    transition: all 0.4s;
                    @media @max-lg {
                        height: 460px;
                    }
                    @media @max-md {
                        height: 420px;
                    }
                    @media @max-sm {
                        height: 380px;
                        width: calc(50% - 16px);
                        flex: 0 0 auto;
                        margin: 0 8px;
                        margin-bottom: 16px;
                    }
                    @media @max-xs {
                        height: 38vw;
                        width: calc(50% - 10px);
                        margin: 0 5px 10px;
                    }
                    @media @max-xn {
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 8px;
                        object-fit: cover;
                    }

                    .img-name-box {
                        width: 100%;
                        padding-bottom: 45px;
                        box-sizing: border-box;
                        background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(255, 118, 37, 0.7));
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;
                        @media @max-lg {
                            padding-bottom: 40px;
                        }
                        @media @max-sm {
                            padding-bottom: 20px;
                        }
                        .name-text {
                            font-size: 20px;
                            color: #fff;
                            letter-spacing: 1px;
                        }
                    }

                    .img-text-content {
                        width: 100%;
                        box-sizing: border-box;
                        padding-left: 40px;
                        padding-right: 40px;
                        background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
                        color: #fff;
                        position: absolute;
                        bottom: 0;
                        padding-bottom: 40px;
                        left: 0;
                        display: none;
                        @media @max-lg {
                            padding: 0 30px 30px;
                        }
                        @media @max-sm {
                            padding: 0 20px 20px;
                        }

                        .img-name {
                            width: 100%;
                            font-size: 26px;
                            margin-bottom: 15px;
                            @media @max-lg {
                                font-size: 22px;
                            }
                            @media @max-lg {
                                font-size: 18px;
                            }
                        }

                        .img-tips {
                            width: 100%;
                            max-width: 585px;
                            height: 68px;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            font-size: 16px;
                            line-height: 26px;
                            height: 26px * 3;
                            letter-spacing: 1px;
                            @media @max-lg {
                                line-height: 24px;
                                height: 24px * 3;
                                font-size: 14px;
                            }
                        }

                        .but {
                            margin: 26px 0 0 0;
                        }
                        .fz_but {
                            display: flex;
                            align-content: center;
                            cursor: pointer;
                        }
                    }
                }

                @media @min-sm {
                    .img-show-div:hover {
                        width: 630px;
                        .img-name-box {
                            display: none;
                        }
                        .img-text-content {
                            display: block;
                        }
                    }
                }

                @media @min-sm {
                    .active {
                        width: 630px;
                        flex: 1 0 initial;
                        .img-name-box {
                            display: none;
                        }
                        .img-text-content {
                            display: block;
                        }
                    }
                }
            }
        }
        .tabs-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: url('../../assets/img/b2.png') no-repeat;
            background-size: cover;
            text-align: center;
            .tabs-box-title {
                font-size: 36px;
                height: 48px;
                color: #000;
                text-align: center;
                font-weight: bold;
                margin: 60px 0 40px 0;
                @media @max-sm {
                    font-size: 32px;
                }
                @media @max-xx {
                    font-size: 24px;
                }
            }
            .tabs-content-box {
                width: 87.5%;
                max-width: 1600px;
                border-radius: 8px;
                background-color: #fff;
                box-sizing: border-box;
                text-align: left;
                @media @max-sm {
                    padding: 30px;
                }
                .name-logo-box {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    @media @max-xs {
                        flex-wrap: wrap;
                    }
                    .head-portrait {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .head-portrait-img {
                            width: 100px;
                            height: 100px;
                            object-fit: cover;
                            border-radius: 50%;
                            object-fit: scale-down;
                            @media @max-xs {
                                width: 80px;
                                height: 80px;
                            }
                        }
                        .name-introduction {
                            margin-left: 15px;
                            .name {
                                color: #121826;
                            }
                            .introduction {
                                color: #999999;
                            }
                        }
                    }
                    .r-logo-img img {
                        max-height: 100px;
                        @media @max-xs {
                            margin-top: 20px;
                        }
                    }
                }
                .introduction-content {
                    width: 100%;
                    min-height: 170px;
                    margin-top: 40px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-image: url('../../assets/cloudProduct/qu_1.png'), url('../../assets/cloudProduct/qu_2.png');
                    background-repeat: no-repeat, no-repeat;
                    background-position: top left, 98.8% 92px;
                    .introduction {
                        max-width: 880px;
                        min-height: 114px;
                        text-align: left;
                        color: #7d89a1;
                        letter-spacing: 1px;
                        line-height: 1.5em;
                        word-break: break-all;
                    }
                }
            }
        }
        .logo-plate {
            background: #f2f4f6;
            padding-bottom: 108px;
            .box-title {
                color: #121826;
                margin-bottom: 4px;
            }
            .tips {
                color: #5a6779;
                margin-bottom: 32px;
            }
            .tabs-content-box {
                width: 83.3vw;
                @media @max-xs {
                    height: 240px;
                    overflow-y: auto;
                    padding: 0 !important;
                    min-height: auto;
                }
                .logo-list {
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    > div {
                        width: 12.5%;
                        height: 14.28%;
                        max-height: 78px;
                    }
                    img {
                        width: 100%;
                        height: auto;
                        max-height: 78px;
                        object-fit: scale-down;
                        // @media @max-xs {
                        //     width: 33.333%;
                        //     height: 60px;
                        // }
                    }
                }
            }
        }
        .cooperation-box {
            width: 100%;
            background-size: cover;
            padding: 35px 0;
            .container1 {
                display: flex;
                align-items: center;
                justify-content: center;
                .cooperation-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    width: 77%;
                    margin-bottom: -32px;
                    @media @max-xs {
                        justify-content: center;
                    }
                    .cooperation-text {
                        color: #fff;
                        font-family: Source Han Sans CN;
                        font-size: 36px;
                        font-weight: 500;
                        letter-spacing: 0;
                        flex-shrink: 0;
                        max-width: 100%;
                        margin-bottom: 32px;
                        @media @max-lg {
                            font-size: 30px;
                        }
                        @media @max-md {
                            font-size: 26px;
                        }
                        @media @max-xs {
                            text-align: center;
                            font-size: 20px;
                        }
                    }
                    .cooperation-btn {
                        width: 130px;
                        height: 45px;
                        background: #ffffff;
                        border-radius: 23px;
                        font-size: 20px;
                        font-family: MiSans;
                        font-weight: 500;
                        color: #ff5d00;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        margin-bottom: 32px;
                    }
                    .contact-img {
                        position: relative;
                        margin-right: 120px;

                        @media @max-md {
                            margin-right: 60px;
                        }
                        @media @max-sm {
                            margin-top: 60px;
                            margin-right: 0;
                            margin: 60px auto 0;
                        }
                        img {
                            width: 260px;
                            height: auto;
                            object-fit: scale-down;
                            &:nth-child(2) {
                                position: absolute;
                                left: 82px;
                                width: 100px;
                                top: 84px;
                            }
                        }
                    }
                }
            }
        }
    }
}
.ptb60 {
    padding: 60px 0;
}
.mt-60-bootstrap {
    margin-top: 60px;
    transition: all 0.4s;
    @media @max-sm {
        margin-top: 40px;
    }
    @media @max-xs {
        margin-top: 20px;
    }
}
</style>
